<!-- Organization General Information -->
<div class="hcol-flex gap-half full-height-container">
    <!-- Left Column: Organization Info + Editable Fields -->
    <div class="hcol-grow flex-column-grow">
        <p-panel class="organization-panel" [ngStyle]="{height: '100%'}">
            <ng-template pTemplate="header">
                <div class="hcol-grow" [ngStyle]="{display: 'flex', 'align-items': 'center', gap: '0.5rem'}">
                    <span class="p-panel-title">Organization information</span>
                    <p-button
                        [text]="true"
                        [rounded]="true"
                        severity="secondary"
                        icon="pi pi-pencil"
                        size="small"
                        (onClick)="openOrganizationModal()"
                    />
                </div>
            </ng-template>

            <div class="flex-column-grow">
                <div class="hcol-flex gap-half w-100 space-around-start">
                    <div class="info-col">
                        <div class="text-bold align-h">Name</div>
                    </div>
                    <div class="info-col" [ngStyle]="{'min-width': '20rem'}">
                        <div class="align-h w-100">
                            @if (isRefreshing) {
                                <p-progressSpinner
                                    styleClass="w-2rem h-2rem"
                                    strokeWidth="4"
                                    animationDuration="1s"
                                ></p-progressSpinner>
                            } @else {
                                <div class="align-h">{{ organization?.name ?? '--' }}</div>
                            }
                        </div>
                    </div>
                    <div class="hcol-grow"></div>
                    <div class="info-col">
                        <div class="align-h">
                            <i class="pi pi-user" [ngStyle]="{'margin-right': '0.5rem'}"></i>
                            <span
                                ><strong>Created by</strong> {{ createdByUser?.email ?? '--' }} <strong>at</strong>
                                {{ organization?.created_at | date: 'yyyy-MM-dd HH:mm' }}</span
                            >
                        </div>
                    </div>
                </div>

                <div class="w-100 mt-1 flex-column-grow">
                    <div class="text-bold align-h mb-1">Description</div>
                    @if (isRefreshing) {
                        <div
                            class="p-3 text-center"
                            [ngStyle]="{
                                border: '1px solid #dee2e6',
                                'border-radius': '8px',
                                'white-space': 'pre-wrap',
                                'flex-grow': '1',
                                display: 'flex',
                                'align-items': 'center',
                                'justify-content': 'center'
                            }"
                        >
                            <p-progressSpinner
                                styleClass="w-3rem h-3rem"
                                strokeWidth="4"
                                animationDuration="1s"
                            ></p-progressSpinner>
                        </div>
                    } @else {
                        <div
                            class="p-3"
                            [ngStyle]="{
                                border: '1px solid #dee2e6',
                                'border-radius': '8px',
                                'white-space': 'pre-wrap',
                                'flex-grow': '1',
                                'overflow-y': 'auto',
                                'min-height': 'calc(100vh - 350px)'
                            }"
                        >
                            {{ organization?.description || 'No description provided' }}
                        </div>
                    }
                </div>
            </div>
        </p-panel>
    </div>

    <!-- Right Column: Overview Statistics -->
    <div [style.width]="'8rem'">
        <p-panel header="Overview" class="title-center">
            <div class="vcol-flex space-around-center">
                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Service Requests"
                            tooltipPosition="left"
                            class="pi pi-list"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ serviceRequestsCount ?? '--' }}</div>
                        <p class="mb-0">Service Requests</p>
                    </div>
                </div>

                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Files"
                            tooltipPosition="left"
                            class="pi pi-file"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ filesCount ?? '--' }}</div>
                        <p class="mb-0">Files</p>
                    </div>
                </div>

                <div class="content-center">
                    <div class="content-center">
                        <span
                            pTooltip="Object Store Entry"
                            tooltipPosition="left"
                            class="pi pi-database"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ objectStoreCount ?? '--' }}</div>
                        <p class="mb-0">Object Store Entry</p>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>
